import axios from "axios";
console.log("[URL]", process.env.REACT_APP_API);
const baseURL = process.env.REACT_APP_API;

export const propertiesApiUsellProvider = axios.create({
  baseURL: baseURL + "/api/properties"
});

export const commercialApiUsellProvider = axios.create({
  baseURL: baseURL + "/api/commercial"
});

export const typologiesApiUsellProvider = axios.create({
  baseURL: baseURL + "/api/typologies"
});

export const networksApiUsellProvider = axios.create({
  baseURL: baseURL + "/api/networks"
});

export const iocsApiUsellProvider = axios.create({
  baseURL: baseURL + "/api/actions"
});

export const actionsApiUsellProvider = axios.create({
  baseURL: baseURL + "/api/actions"
});

export const eventsApiUsellProvider = axios.create({
  baseURL: baseURL + "/api/events"
});

export const eventApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/event"
});

export const eventTypesApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/event_types"
});

export const userApiProvider = axios.create({
  baseURL: baseURL + "/api/user"
});

export const modelsApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/models"
});

export const merchApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/models_merch"
});
export const modelApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/model"
});

export const authApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/auth"
});

export const rolesApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/roles"
});

export const aclApiUsellProvider = axios.create({
  baseURL: baseURL + "/api/access"
});

export const servicesApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/services"
});

export const usersApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/users"
});

export const clientsApiProvider = axios.create({
  baseURL: baseURL + "/api/clients"
});

export const kpiApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/kpi"
});

export const retailersApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/retailer"
});

export const surveysApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/surveys"
});

export const surveyApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/survey"
});

export const assortmentApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/assortment"
});

export const locationApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/location"
});

export const sectorApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/sector"
});

export const sectorsApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/sectors"
});

export const userApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/user"
});

export const importApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/import"
});

export const photothequeApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/phototheque"
});

export const mediasApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/medias"
});

export const visitApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/visit"
});

export const visitsApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/visits"
});

export const logsApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/logs"
});

export const kpisApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/kpis"
});

export const actionsApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/actions"
});

export const pdcsApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/pdcs"
});

export const requestApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/request"
});
export const requestsApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/requests"
});

export const contactsApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/contacts"
});

export const georegionsApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/georegions"
});

export const activeRangesApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/activerange"
});

export const rangesApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/ranges"
});

export const vacationApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/vacation"
});

export const vacationsApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/vacations"
});

export const attendancesApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/attendances"
});

export const absenceTypesApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/absencetypes"
});

export const luccaApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/lucca"
});

export const expenseReportsListApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/expenses"
});

export const expenseReportsWeeklyApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/expenses/users/week"
});

export const expenseNoSReportsApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/expense"
});

export const expenseRejectTypesApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/expense_reject_types"
});

export const premiumsApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/bonuses"
});

export const exportTransferOrder = axios.create({
  // baseURL: baseURL + "/api/expenses/generate_transfers"
  baseURL: baseURL + "/api/transfer/"
});

// assortmentApiUpsellProvider.defaults.headers.post["Content-Type"] =
// 	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const transfersByUsersProvider = axios.create({
  baseURL: baseURL + "/api/transfer/expensesReadyToTransferByUser"
});

export const transfersProvider = axios.create({
  baseURL: baseURL + "/api/transfers/"
});

export const transfersDetailsProvider = axios.create({
  baseURL: baseURL + "/api/transfers_details/"
});

export const downloadTransferOrderProvider = axios.create({
  baseURL: baseURL + "/api/transfer/downloadtransferxml/"
});

export const downloadTransferExportComptaProvider = axios.create({
  baseURL: baseURL + "/api/transfer/downloadexportcompta/"
});

export const downloadTransferExportBanqueProvider = axios.create({
  baseURL: baseURL + "/api/transfer/downloadexportbanque/"
});

export const validateTransferOrderProvider = axios.create({
  baseURL: baseURL + "/api/transfer/validate/"
});

export const rejectTransferOrderProvider = axios.create({
  baseURL: baseURL + "/api/transfer/reject/"
});

export const transferUserDeductionCurrentProvider = axios.create({
  baseURL: baseURL + "/api/deduction/current/"
});

export const transferUserDeductionProvider = axios.create({
  baseURL: baseURL + "/api/deduction"
});

export const presenceAttendanceProgression = axios.create({
  baseURL: baseURL + "/api/attendances/progression"
});

export const presenceDetailsDay = axios.create({
  baseURL: baseURL + "/api/attendances/details/day"
});

export const presenceDetailsWeek = axios.create({
  baseURL: baseURL + "/api/attendances/details/week"
});

export const presenceUpdateAttendance = axios.create({
  baseURL: baseURL + "/api/attendance/"
});
export const presenceUpdateMealPackage = axios.create({
  baseURL: baseURL + "/api/mealpackage/"
});

export const presenceTripProvider = axios.create({
  baseURL: baseURL + "/api/trip"
});

export const presenceTripsProvider = axios.create({
  baseURL: baseURL + "/api/trips"
});

export const presenceValidateTrips = axios.create({
  baseURL: baseURL + "/api/trips/validate"
});

export const presenceValidateAttendances = axios.create({
  baseURL: baseURL + "/api/attendances/validate"
});

export const presenceValidateMealPackages = axios.create({
  baseURL: baseURL + "/api/mealpackages/validate"
});

export const presenceVacationsProvider = axios.create({
  baseURL: baseURL + "/api/vacations"
});

export const sectorPdcsProvider = axios.create({ baseURL: baseURL + "/api/sector_pdcs" });

export const statsApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/statistics"
});

export const uploadApiUpsellProvider = axios.create({
  baseURL: baseURL + "/api/upload"
});

const setHeaders = async function(config = {}) {
  config.headers = config.headers || {};
  if (!config.headers["Authorization"]) {
    config.headers["Authorization"] = localStorage.getItem("access_token");
  }
  return config;
};

//TODO create global middleware
//Add token to each request
statsApiUpsellProvider.interceptors.request.use(setHeaders, error => {
  return Promise.reject(error);
});
mediasApiUpsellProvider.interceptors.request.use(setHeaders, error => {
  return Promise.reject(error);
});
uploadApiUpsellProvider.interceptors.request.use(setHeaders, error => {
  return Promise.reject(error);
});
visitApiUpsellProvider.interceptors.request.use(setHeaders, error => {
  return Promise.reject(error);
});
visitsApiUpsellProvider.interceptors.request.use(setHeaders, error => {
  return Promise.reject(error);
});
presenceTripsProvider.interceptors.request.use(setHeaders, error => {
  return Promise.reject(error);
});



// WEBPACK FOOTER //
// src/lib/api/providers.js